import HeaderMenu from "../sidebar/headermenu";
import { Field, Formik } from "formik";
import { useEffect, useState } from "react";
import * as Yup from "yup";
import { API_STATUS } from "../../constants";
import { useNavigate } from "react-router-dom";
import { CreateEventApi, UploadChunkApi, CommitFilesApi, CreateAdpostApi } from "../../apis/event/create_event_api";
import SelectMediaModal from "./select_media_model";
import { comitChunksWeb, uploadChunksWeb } from "./web_upload_chunks";
import { EventNoteAllApi } from "../../apis/notification/event_note_all";
import { PostNoteAllApi } from "../../apis/notification/post_note_all";
import { useUpload } from "./upload_context";

const CHUNK_SIZE = 2 * 1024 * 1024; // 2 MB Chunk Size

export default function CreateEvent() {
    const navigate = useNavigate();
    const [step, setStep] = useState(1);
    const [publishType, setPublishType] = useState("event"); // 'event' or 'adpost'
    const [selFiles, setFiles] = useState([]);
    const [ApiStatus, setApiStatus] = useState(API_STATUS);
    const [uploadStatus, setUploadStatus] = useState({
        isLoading: false,
        message: "",
        progress: 0,
    });

    const { startBackgroundUpload } = useUpload();

    useEffect(() => {
        if (sessionStorage.getItem("LIVENESS") === '0') {
            navigate("/video_kyc_pending");
        }
    }, []);

    useEffect(() => {
        const token = sessionStorage.getItem("LOGIN_TOKEN");
        if (token == null) {
            navigate("/login");
        }
    }, [navigate]);

    // Dynamic Yup Schema based on Publish Type
    const getValidationSchema = () => {
        if (publishType === "event") {
            return Yup.object().shape({
                title: Yup.string().min(2, "Too Short!").required("Enter event title"),
                desc: Yup.string().min(20, "Enter minimum 20 characters").required("Enter event description"),
                startDate: Yup.string().required("Start date required"),
                lastDate: Yup.string().required("Registration date required"),
                state: Yup.string().required("Enter state"),
                city: Yup.string().required("Enter city"),
                address: Yup.string().required("Enter address"),
                pincode: Yup.string().required("Enter pincode"),
                amount: Yup.string().required("Enter amount"),
            });
        } else {
            return Yup.object().shape({
                buttonType: Yup.string().required("Select action type"),
                buttonLink: Yup.string().url("Enter a valid URL").required("Link is required"),
            });
        }
    };


    const submitData = async (values) => {
        try {
            const payload = {
                ...values,
                publishType,
            };

            payload.link = payload['buttonLink'];
            payload.caption = payload['title'];

            setUploadStatus({ isLoading: true, message: `Creating ${publishType === 'event' ? 'Event' : 'Ad Post'}...`, progress: 0 });

            // 1. Create record
            let eventId;

            if (publishType === "event") {
                const eventRes = await CreateEventApi(payload);
                eventId = eventRes?.data?.id || eventRes?.data?.eventId;
            } else {
                const adpostRes = await CreateAdpostApi(payload);
                eventId = adpostRes?.data?.id || adpostRes?.data?.eventId;
            }

            if (!eventId) {
                alert("Failed to retrieve ID");
                return;
            }

            // 2. Upload files
            if (selFiles.length > 0) {
                // for (let i = 0; i < selFiles.length; i++) {
                //     const file = selFiles[i];
                //     const isVideo = file.type.startsWith('video');
                //     const mediaType = isVideo ? 'video' : 'image';

                //     setUploadStatus({
                //         isLoading: true,
                //         message: `Uploading media ${i + 1} of ${selFiles.length}: ${file.name}`,
                //         progress: 0
                //     });

                //     const uploadRes = await uploadChunksWeb(
                //         eventId,
                //         file,
                //         (progress) => {
                //             setUploadStatus(prev => ({ ...prev, progress: Math.round(progress) }));
                //         },
                //         publishType
                //     );

                //     const cropData = {
                //         index: i,
                //         cropFrame: { x: 0, y: 0, width: 1, height: 1, scale: 1, rotation: 0 },
                //         aspectRatio: 1,
                //         filter: 'normal',
                //         lockedAspectRatio: 1
                //     };

                //     const commitPayload = {
                //         eventId: eventId,
                //         uploadId: uploadRes.uploadId,
                //         totalChunks: uploadRes.totalChunks,
                //         fileName: file.name,
                //         cropData: cropData,
                //         type: mediaType
                //     };

                //     await comitChunksWeb(commitPayload, publishType);
                // }

                await startBackgroundUpload({ eventId, selFiles, publishType,setUploadStatus });
            }

            // setUploadStatus({ isLoading: false, message: "", progress: 100 });
            navigate(publishType === "event" ? "/" : "/posts");
            // if (publishType === "event") {
            //     EventNoteAllApi(eventId);
            //     navigate("/");
            // } else {
            //     PostNoteAllApi(eventId);
            //     navigate("/posts");
            // }
        } catch (err) {
            console.error("Submission error:", err);
            setUploadStatus({ isLoading: false, message: "", progress: 0 });
            alert("Failed to create post. Please try again.");
        }
    };

    useEffect(() => {
        const handleBeforeUnload = (e) => {
            if (uploadStatus.isLoading) {
                e.preventDefault();
                e.returnValue = "Upload is currently in progress. Are you sure you want to exit?";
                return e.returnValue;
            }
        };

        window.addEventListener("beforeunload", handleBeforeUnload);
        return () => window.removeEventListener("beforeunload", handleBeforeUnload);
    }, [uploadStatus.isLoading]);

    return (
        <div id="wrapper">
            <HeaderMenu />
            <main className="2xl:ml-[--w-side] xl:ml-[--w-side-md] md:ml-[--w-side-small] py-8">
                <div className="max-w-2xl mx-auto px-4">



                    {/* Progress Indicator */}
                    <div className="flex items-center justify-center gap-4 mb-8">
                        <div className={`flex items-center gap-2 text-xs font-bold uppercase tracking-wider ${step === 1 ? 'text-blue-600' : 'text-slate-400'}`}>
                            <span className={`w-6 h-6 rounded-full flex items-center justify-center text-white ${step === 1 ? 'bg-blue-600' : 'bg-slate-300'}`}>1</span>
                            Select Media
                        </div>
                        <div className="w-12 h-0.5 bg-slate-200"></div>
                        <div className={`flex items-center gap-2 text-xs font-bold uppercase tracking-wider ${step === 2 ? 'text-blue-600' : 'text-slate-400'}`}>
                            <span className={`w-6 h-6 rounded-full flex items-center justify-center text-white ${step === 2 ? 'bg-blue-600' : 'bg-slate-300'}`}>2</span>
                            {publishType === "event" ? "Event Details" : "Adpost Details"}
                        </div>
                    </div>

                    {/* STEP 1: Select Media */}
                    {step === 1 && (
                        <SelectMediaModal
                            selFiles={selFiles}
                            setFiles={setFiles}
                            onNext={() => setStep(2)}
                        />
                    )}

                    {/* STEP 2: Conditional Form */}
                    {step === 2 && (
                        <div className="bg-white border rounded-xl shadow-sm md:py-8 md:px-12 p-6 dark:border-slate-700 dark:bg-dark2 relative">
                            <div className="flex items-center justify-between pb-4 mb-6 border-b border-slate-100 dark:border-slate-700">
                                <div className="flex items-center gap-2 text-xs font-semibold text-slate-600 dark:text-slate-300">
                                    <span>📎 Attached Media:</span>
                                    <span className="bg-blue-50 text-blue-600 px-2.5 py-0.5 rounded-full font-bold">
                                        {selFiles.length} file(s) selected
                                    </span>
                                </div>
                                <button
                                    type="button"
                                    onClick={() => setStep(1)}
                                    className="text-xs text-blue-600 hover:underline font-semibold"
                                >
                                    ← Change Media
                                </button>
                            </div>

                            {/* Publish Type Selector */}
                            <div className="mb-6">
                                <label className="block mb-2 font-bold text-slate-700 dark:text-slate-200 text-sm">
                                    Publish As
                                </label>
                                <div className="flex items-center gap-6 text-sm font-semibold">
                                    <label className="flex items-center gap-2 cursor-pointer">
                                        <input
                                            type="radio"
                                            name="publishType"
                                            value="event"
                                            checked={publishType === "event"}
                                            onChange={(e) => setPublishType(e.target.value)}
                                            className="w-4 h-4 text-blue-600"
                                        />
                                        <span className="text-slate-700 dark:text-slate-200">Event</span>
                                    </label>
                                    <label className="flex items-center gap-2 cursor-pointer">
                                        <input
                                            type="radio"
                                            name="publishType"
                                            value="adpost"
                                            checked={publishType === "adpost"}
                                            onChange={(e) => setPublishType(e.target.value)}
                                            className="w-4 h-4 text-blue-600"
                                        />
                                        <span className="text-slate-700 dark:text-slate-200">Adpost</span>
                                    </label>
                                </div>
                            </div>

                            <Formik
                                initialValues={{
                                    title: "",
                                    desc: "",
                                    startDate: "",
                                    endDate: "",
                                    lastDate: "",
                                    state: "",
                                    city: "",
                                    address: "",
                                    pincode: "",
                                    amount: "0",
                                    buttonType: "buy",
                                    buttonLink: "",
                                }}
                                validationSchema={getValidationSchema()}
                                onSubmit={(values) => submitData(values)}
                            >
                                {({ errors, touched, isValid, setFieldTouched, handleSubmit }) => (
                                    <div className="space-y-5 text-sm font-medium text-gray-600 dark:text-white/80">

                                        {/* EVENT FORM FIELDS */}
                                        {publishType === "event" ? (
                                            <>
                                                <div>
                                                    <label className="block mb-1 font-bold text-slate-700 dark:text-slate-200">Event Title *</label>
                                                    <Field type="text" name="title" className="w-full form-input" placeholder="Enter title" />
                                                    {errors.title && touched.title && <div className="text-red-400 text-xs mt-1">{errors.title}</div>}
                                                </div>

                                                <div>
                                                    <label className="block mb-1 font-bold text-slate-700 dark:text-slate-200">Description *</label>
                                                    <Field as="textarea" name="desc" className="w-full form-input" rows="4" />
                                                    {errors.desc && touched.desc && <div className="text-red-400 text-xs mt-1">{errors.desc}</div>}
                                                </div>

                                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                                                    <div>
                                                        <label className="block mb-1 font-bold text-slate-700 dark:text-slate-200">State *</label>
                                                        <Field type="text" name="state" className="w-full form-input" />
                                                        {errors.state && touched.state && <div className="text-red-400 text-xs mt-1">{errors.state}</div>}
                                                    </div>
                                                    <div>
                                                        <label className="block mb-1 font-bold text-slate-700 dark:text-slate-200">City *</label>
                                                        <Field type="text" name="city" className="w-full form-input" />
                                                        {errors.city && touched.city && <div className="text-red-400 text-xs mt-1">{errors.city}</div>}
                                                    </div>
                                                </div>

                                                <div>
                                                    <label className="block mb-1 font-bold text-slate-700 dark:text-slate-200">Full Address *</label>
                                                    <Field as="textarea" name="address" className="w-full form-input" rows="2" />
                                                    {errors.address && touched.address && <div className="text-red-400 text-xs mt-1">{errors.address}</div>}
                                                </div>

                                                <div>
                                                    <label className="block mb-1 font-bold text-slate-700 dark:text-slate-200">Pincode *</label>
                                                    <Field type="text" name="pincode" className="w-full form-input" />
                                                    {errors.pincode && touched.pincode && <div className="text-red-400 text-xs mt-1">{errors.pincode}</div>}
                                                </div>

                                                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
                                                    <div>
                                                        <label className="block mb-1 font-bold text-slate-700 dark:text-slate-200">Start Date *</label>
                                                        <Field type="date" name="startDate" className="w-full form-input" />
                                                        {errors.startDate && touched.startDate && <div className="text-red-400 text-xs mt-1">{errors.startDate}</div>}
                                                    </div>
                                                    <div>
                                                        <label className="block mb-1 font-bold text-slate-700 dark:text-slate-200">End Date</label>
                                                        <Field type="date" name="endDate" className="w-full form-input" />
                                                    </div>
                                                    <div>
                                                        <label className="block mb-1 font-bold text-slate-700 dark:text-slate-200">Last Reg. Date *</label>
                                                        <Field type="date" name="lastDate" className="w-full form-input" />
                                                        {errors.lastDate && touched.lastDate && <div className="text-red-400 text-xs mt-1">{errors.lastDate}</div>}
                                                    </div>
                                                </div>

                                                <div>
                                                    <label className="block mb-1 font-bold text-slate-700 dark:text-slate-200">Registration Fee (₹) *</label>
                                                    <Field type="number" name="amount" className="w-full form-input" placeholder="0 for Free" />
                                                    {errors.amount && touched.amount && <div className="text-red-400 text-xs mt-1">{errors.amount}</div>}
                                                </div>
                                            </>
                                        ) : (
                                            /* ADPOST FORM FIELDS */
                                            <>

                                                <div>
                                                    <label className="block mb-1 font-bold text-slate-700 dark:text-slate-200">Caption</label>
                                                    <Field type="text" name="title" className="w-full form-input" placeholder="Enter caption" />
                                                    {errors.title && touched.title && <div className="text-red-400 text-xs mt-1">{errors.title}</div>}
                                                </div>

                                                <div>
                                                    <label className="block mb-2 font-bold text-slate-700 dark:text-slate-200">
                                                        Action Button Type *
                                                    </label>
                                                    <div className="flex items-center gap-6">
                                                        <label className="flex items-center gap-2 cursor-pointer">
                                                            <Field
                                                                type="radio"
                                                                name="buttonType"
                                                                value="buy"
                                                                className="w-4 h-4 text-blue-600"
                                                            />
                                                            <span className="text-slate-700 dark:text-slate-200">Buy Now</span>
                                                        </label>
                                                        <label className="flex items-center gap-2 cursor-pointer">
                                                            <Field
                                                                type="radio"
                                                                name="buttonType"
                                                                value="visit"
                                                                className="w-4 h-4 text-blue-600"
                                                            />
                                                            <span className="text-slate-700 dark:text-slate-200">Visit</span>
                                                        </label>
                                                    </div>
                                                    {errors.buttonType && touched.buttonType && (
                                                        <div className="text-red-400 text-xs mt-1">{errors.buttonType}</div>
                                                    )}
                                                </div>

                                                <div>
                                                    <label className="block mb-1 font-bold text-slate-700 dark:text-slate-200">
                                                        Button Target Link *
                                                    </label>
                                                    <Field
                                                        type="text"
                                                        name="buttonLink"
                                                        className="w-full form-input"
                                                        placeholder="https://example.com"
                                                    />
                                                    {errors.buttonLink && touched.buttonLink && (
                                                        <div className="text-red-400 text-xs mt-1">{errors.buttonLink}</div>
                                                    )}
                                                </div>
                                            </>
                                        )}

                                        {/* Actions */}
                                        <div className="flex items-center justify-between pt-6 border-t border-slate-100">
                                            <button
                                                type="button"
                                                onClick={() => setStep(1)}
                                                className="px-6 py-2.5 rounded-full border border-slate-300 text-slate-600 font-medium text-sm hover:bg-slate-50"
                                            >
                                                Back
                                            </button>

                                            <button
                                                type="button"
                                                onClick={() => {
                                                    if (!isValid) {
                                                        console.log('not valid');
                                                        if (publishType === "event") {
                                                            ["title", "desc", "state", "city", "address", "pincode", "startDate", "lastDate", "amount"].forEach((f) => setFieldTouched(f));
                                                        } else {
                                                            ["actionType", "buttonLink"].forEach((f) => setFieldTouched(f));
                                                        }
                                                    } else {
                                                        console.log('working');
                                                        handleSubmit();
                                                    }
                                                }}
                                                className="px-8 py-2.5 rounded-full bg-blue-600 text-white font-bold text-sm hover:bg-blue-700 shadow-md"
                                            >
                                                {publishType === "event" ? "Publish Event" : "Publish Adpost"}
                                            </button>
                                        </div>
                                    </div>
                                )}
                            </Formik>

                            {/* Chunk Upload Overlay */}
                            {uploadStatus.isLoading && (
                                <div className="absolute inset-0 bg-white/95 dark:bg-dark2/95 flex flex-col items-center justify-center p-6 rounded-xl z-20">
                                    <p className="text-sm font-bold text-slate-700 dark:text-slate-200 mb-3">
                                        {uploadStatus.message}
                                    </p>
                                    <div className="w-full max-w-xs bg-gray-200 rounded-full h-3 overflow-hidden">
                                        <div
                                            className="bg-blue-600 h-3 transition-all duration-300"
                                            style={{ width: uploadStatus.progress + "%" }}
                                        ></div>
                                    </div>
                                    <span className="text-xs text-slate-500 mt-2 font-semibold">
                                        {uploadStatus.progress}%
                                    </span>
                                </div>
                            )}

                        </div>
                    )}

                </div>
            </main>
        </div>
    );
}